import Vue from 'vue';
import VueGtm from 'vue-gtm';
import unionInputs from 'union_inputs';
import unionAddress from 'union_address';
import unionComponents from 'union_components';
import kotlin from 'union_kotlin';
import axios from 'axios';
import VueMask from 'v-mask';
import App from '@/App.vue';
import router from '@/router';
import store from '@/store';

// https://www.npmjs.com/package/vue-gtm
Vue.use(VueGtm, {
  id: 'GTM-MQMNF7',
  queryParams: {},
  defer: false,
  enabled: true,
  debug: true,
  loadScript: true,
  vueRouter: false,
  ignoredViews: [],
});

Vue.config.productionTip = false;
axios.defaults.headers['Content-Type'] = 'application/json;charset=UTF-8';
Vue.prototype.$axios = axios;
Vue.prototype.$t = () => {};

Vue.use(unionInputs);
Vue.use(unionAddress);
Vue.use(unionComponents);
Vue.use(VueMask);
// eslint-disable-next-line
Vue.use(kotlin, uzp_web_kotlin.com.aston.union.uzpweb);

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
